import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { OccupationalDoctorService } from '@/infra/services/occupational-doctor';

interface DestroyOccupationalDoctorParams {
	id: string;
	company_id: string;
	organization_id: string;
}

const Service = OccupationalDoctorService.getInstance();

export const useDestroyOccupationalDoctor = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (params: DestroyOccupationalDoctorParams) => Service.destroy(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_OCCUPATIONAL_DOCTOR]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_LIST_OCCUPATIONAL_DOCTOR]);
			message.success(I18n.get('Occupational doctor destroyed successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error on destroy occupational doctor'));
		}
	});
};
